<template>
  <div class="model-second-gg-content">
    {{rowData.body}}
  </div>
</template>

<script>
export default {
  name: 'v-title',
  props: ['params', 'rowData']
}
</script>

<style lang="less">
@import "../../../styles/index.less";
</style>
